export default {
  en: {
    page: {
      title: 'License Catalogs',
      text: 'Here you find all the questions you can practice. You can start with any of the licenses and categories, but we recommend you to start and stick with the one you want to get the license for.'
    },
    'Try today for free!': 'Try today for free!',
    'Completed positively': 'Completed positively',
    Questions: 'Questions',
    'Questions seen': 'Questions seen',
    'Questions solved positively': 'Questions solved positively',
  },
  de: {
    page: {
      title: 'Lizenzkataloge',
      text: 'Hier finden Sie alle Fragen, die Sie üben können. Sie können mit einer beliebigen Lizenz und Kategorie beginnen, aber wir empfehlen Ihnen, mit derjenigen zu beginnen und dabei zu bleiben, für die Sie die Lizenz erhalten möchten.'
    },
    'Try today for free!': 'Heute kostenlos testen!',
    'Completed positively': 'Positiv abgeschlossen',
    Questions: 'Fragen',
    'Questions seen': 'Fragen gesehen',
    'Questions solved positively': 'Fragen positiv gelöst',
  },
  at: {},
  es: {
    page: {
      title: 'Catálogos de licencias',
      text: 'Aquí encontrarás todas las preguntas que puedes practicar. Puedes comenzar con cualquiera de las licencias y categorías, pero te recomendamos que comiences y te mantengas con la que desees obtener la licencia.'
    },
    'Try today for free!': '¡Pruébalo hoy gratis!',
    'Completed positively': 'Completado positivamente',
    Questions: 'Preguntas',
    'Questions seen': 'Preguntas vistas',
    'Questions solved positively': 'Preguntas resueltas positivamente',
  },
  uk: {
    page: {
      title: 'Каталоги ліцензій',
      text: 'Тут ви знайдете всі питання, які ви можете вивчити. Ви можете почати з будь-якої з ліцензій та категорій, але ми радимо вам почати та залишатися з тією, для якої ви хочете отримати ліцензію.'
    },
    'Try today for free!': 'Спробуйте сьогодні безкоштовно!',
    'Completed positively': 'Завершено позитивно',
    Questions: 'Питання',
    'Questions seen': 'Питання переглянуті',
    'Questions solved positively': 'Питання вирішені позитивно',
  },
}
